var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlog(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6 70h51.567A5.833 5.833 0 0070 64.165V13.334H18.334v50.833a5.833 5.833 0 01-5.734 5.832zm49.067-36.666h-16.25v3.333h16.25v-3.333zm0 7.5h-16.25v3.333h16.25v-3.333zm0 7.5h-16.25v3.333h16.25v-3.333zm0 7.5h-35v3.333h35v-3.333z",
    fill: "url(#paint0_linear_1288_34611)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M6.666 40.001v24.166a5.833 5.833 0 0011.666 0V40H6.666z",
    fill: "#76808F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.666 51.667h14.583V33.333H26.666v18.334z",
    fill: "url(#paint1_linear_1288_34611)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55 25H33.335v-3.333h21.667V25z",
    fill: "url(#paint2_linear_1288_34611)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M6.666 25l3.333 3.333L13.333 25l-3.334-3.333L6.666 25zM60 75.833l2.5 2.5 2.5-2.5-2.5-2.5-2.5 2.5zM73.334 40h2.5v-2.5h-2.5V40z",
    fill: "#76808F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1288_34611",
    x1: 41.25,
    y1: 13.334,
    x2: 41.25,
    y2: 69.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76808F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#929AA5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1288_34611",
    x1: 33.958,
    y1: 51.667,
    x2: 33.958,
    y2: 33.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B90B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8D33A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1288_34611",
    x1: 33.334,
    y1: 23.333,
    x2: 55.001,
    y2: 23.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B90B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8D33A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog);
export default __webpack_public_path__ + "static/media/blog.25b242e559973c630973aa96eaaeeef2.svg";
export { ForwardRef as ReactComponent };